<template>
  <div class="widget">
    <div class="widget-label">
      <div class="label">
        <p>{{ title }}</p>
      </div>
      <b-button
        v-if="addNewText && checkStatus"
        @click="addNew(addNewText)"
        variant="primary"
        class="right-align"
      >
        Add New {{ addNewText }}
      </b-button>
    </div>

    <b-tabs fluid>
      <b-tab v-for="(item, i) in items" :key="i" :active="item.active">
        <template v-slot:title>
          <b-icon :icon="item.icon"></b-icon> {{ item.title }}
          <span v-if="item.projectMetrics.length" class="notice">
            {{ item.projectMetrics.length }}
          </span>
        </template>

        <div class="action-items widget-content">
          <ProjectMetricEntries
            :projectMetrics="limitedProjectMetrics(item.projectMetrics)"
            :fields="fields"
            :parentItem="item"
            :projectUsers="projectUsers"
            @closeItem="closeProjectMetric"
            @undoItem="undoMarkClosed"
            @refresh="refreshProjectMetric"
          />

          <div v-if="item.projectMetrics.length > length" class="btn-wrapper">
            <b-button
              v-if="item.projectMetrics.length - 6 > length"
              variant="tertiary"
              class="view"
              @click="length += 6"
            >
              View 6 More
            </b-button>
            <b-button
              variant="tertiary"
              class="view"
              @click="length += item.projectMetrics.length"
            >
              View All
            </b-button>
          </div>
        </div>

        <EditProjectMetricModal
          v-if="!item.action"
          :ref="`add-${slugify(addNewText)}-modal`"
          :projectId="$route.params.id"
          :title="`Add New ${addNewText}`"
          mode="Add"
          :possibleAssignees="item.possibleAssignees"
          :addTypes="item.addTypes"
          :presetTags="projectSummary.project.presetTags"
          :meetingId="$route.params.meetingId"
          @submit="addProjectMetricSubmit(item)"
        />

        <EditProjectMetricModal
          v-if="item.action === 'Edit'"
          :ref="`edit-${slugify(addNewText)}-modal`"
          :projectId="$route.params.id"
          :projectMetric="currentMetric"
          :possibleAssignees="item.possibleAssignees"
          :addTypes="item.addTypes"
          :presetTags="projectSummary.project.presetTags"
          :dataTemplate="
            dataTemplateByType(
              item.projectMetrics ? item.projectMetrics.type : null
            )
          "
          :meetingId="$route.params.meetingId"
          @submit="editProjectMetricSubmit(item)"
        />

        <CloseProjectMetricModal
          v-if="item.action === 'Close'"
          :ref="`close-${slugify(addNewText)}-modal`"
          :projectId="$route.params.id"
          :title="`Close &quot;${limitText(currentMetric)}&quot;`"
          mode="Close"
          :projectMetric="currentMetric"
          :possibleAssignees="item.possibleAssignees"
          :addTypes="item.addTypes"
          :meetingId="$route.params.meetingId"
          @add-Resolution-Metric="openAddModal($event)"
          @submit="closeProjectMetricSubmit(item)"
        />
        <EditProjectMetricModal
          :ref="'add-project-metric-reason-modal'"
          :projectId="$route.params.id"
          :title="`Add New ${newAddTypesText}`"
          mode="Add"
          :addTypes="newAddTypes"
          :addingGroupProjects="allowAdd"
          :projectMetric="viewingNewMetric"
          :previousMetric="currentMetric"
          :possibleAssignees="projectUsers"
          :presetTags="projectSummary.project.presetTags"
          :meetingId="$route.params.meetingId"
          needsCancelConfirmed
          @submit="closeItemAndSubmitReason"
        />

      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import axios from "axios";

import ProjectMetricEntries from "@/components/list-entries/ProjectMetricEntries.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";
import CloseProjectMetricModal from "@/components/modals/CloseProjectMetricModal.vue";

export default {
  name: "ActionItemsTabs",
  components: {
    ProjectMetricEntries,
    EditProjectMetricModal,
    CloseProjectMetricModal
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    addNewText: {
      type: String,
    },
    items: {
      type: Array,
      required: true,
    },
    length: {
      type: Number,
      default: 6,
    },
    projectSummary: {
      type: Object,
    },
    projectTags: {
      type: Array,
    },
    status: {
      type: String,
    },
    projectUsers: { type: Array, default: () => [] },
     projectMetrics: { type: Array, default: () => [] },
    possibleAssignees: { type: Array, default: () => [] },
  },
  data() {
    return {
      currentMetric: null,
      newProjectMetric: null,
      allowAdd : false,
      newAddTypes : [],
      newAddTypesText : '',
      assignees: []
    };
  },
  methods: {
    slugify(text) {
      return text.toLowerCase().replace(/\s+/g, "-");
    },
    modalReference(text) {
      return `all-${this.slugify(text)}`;
    },
    limitedProjectMetrics(array) {
      return array.slice(0, this.length);
    },
    addNew(text) {
      let ref = `add-${this.slugify(text)}-modal`;
      this.$refs[ref][0].show();
    },
    addProjectMetricSubmit(item) {
      let ref = `add-${this.slugify(this.addNewText)}-modal`;
      this.$emit("update", "new");
      this.$refs[ref][0].hide();
    },
    editProjectMetricSubmit() {
      let ref = `edit-${this.slugify(this.addNewText)}-modal`;
      this.$emit("refresh");
      this.$refs[ref].cancel();
    },
    closeProjectMetric(item) {
      this.currentMetric = item;

      let ref = `close-${this.slugify(this.addNewText)}-modal`;
      this.$refs[ref][0].show();
    },
    dataTemplateByType(type) {
      if (type === "Innovation" || type === "Efficiency") {
        return {
          show: ["costSaved", "timeSaved", "dateIdentified"],
          hide: ["due"],
          renames: [],
          overrides: [
            {
              actions: ["Add"],
              key: "status",
              value: "Closed",
            },
          ],
        };
      }
      return null;
    },
    closeProjectMetricSubmit(item) {
      let ref = `close-${this.slugify(this.addNewText)}-modal`;
      if(!this.allowAdd){
        this.$emit("update");
      }
      this.$refs[ref][0].cancel();
    },
    undoMarkClosed(data, item) {

      let request = {
        ...data,
        dateClosed: null,
        resolution: "",
        resolutionLevel: "",
        dateResolved: null,
        resolvedBy: "",
        timeSaved: null,
        costSaved: null,
        mitigationMethod: "",
        mitigationMethodData: "",
        status: "Open",
      };

      let url = `${this.$api_url}/project-metrics/update`;
      if (this.$route.params.meetingId) {
        url += `?meetingId=${this.$route.params.meetingId}`;
      }

      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
          this.$emit("update");
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.$emit("update");
        });
    },
    limitText(text, length = 30) {
      if (!text) return "";
      if (text.name.length > length) return text.name.slice(0, length) + "...";
      return text.name;
    },
    refreshProjectMetric(id) {
      let newIndex = this.items[1].projectMetrics.findIndex(
        (p) => p.projectMetricId === id
      );
      let closeIndex = this.items[2].projectMetrics.findIndex(
        (p) => p.projectMetricId === id
      );

      this.$emit("refresh", {
        name: "project-metrics",
        id: id,
        new: newIndex !== -1,
        close: closeIndex !== -1,
      });
    },
    addProjectMetricReasonSubmit() {
      let ref = `add-${this.slugify(this.addNewText)}-modal`;
      this.$emit("update", "closed");
      this.$refs[ref][0].hide();
    },
    closeItemAndSubmitReason() {
      let request = this.currentMetric;

      request.status = 'Closed';
      request.dateClosed = new Date();
      request.dateResolved = request.dateClosed;
      request.resolutionReason = this.newAddTypes.join(',');

      let url = `${this.$api_url}/project-metrics/update`;
      if (this.$route.params.meetingId) {
        url += `?meetingId=${this.$route.params.meetingId}`;
      }
      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
            this.$emit("update");
            this.addProjectMetricReasonSubmit();
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.$emit("update");          
        });
    },
    openAddModal(newMetric) {
      this.newProjectMetric = newMetric;
      this.assignees = newMetric.assignedToUsers;
      this.newAddTypes = newMetric.type.split(',');
      this.newAddTypesText = this.createAddTypesPhrase(this.removeEmptyAddTypes(this.newAddTypes));
      this.$nextTick(() => {
        this.allowAdd = true;
        let ref = `add-project-metric-reason-modal`;
        this.$refs[ref][0].show();
      });
    },
    closeAddModal(item) {
      this.allowAdd = false;
      let ref = `add-project-metric-reason-modal`;
      this.$emit("update", "new");
      this.$refs[ref][0].hide();
    },
    createAddTypesPhrase(addTypes) {
      const length = addTypes.length;

      switch (length) {
        case 0:
          return '';
        case 1:
          return addTypes[0];
        case 2:
          return addTypes.slice(0, -1).join(', ') + ' & ' + addTypes.slice(-1);
        default:
          return addTypes.slice(0, -1).join(', ') + ', & ' + addTypes.slice(-1);
      }
    },
    removeEmptyAddTypes(addTypes) {
      return addTypes.filter(addType => addType.trim().length > 0);
    }
  },
  computed: {
    checkStatus() {
      return this.status !== "Closed";
    },
    fields() {
      let fields = [
        { key: "name", label: "", tdClass: "meta-header" },
        { key: "champion", label: "Champion(s)" },
        { key: "identifiedByRole", label: "Who Identified" },
        { key: "daysOpen", label: "Days Open" },
        { key: "comments", label: "Comments" },
        {
          key: "status",
          label: "Status",
          tdClass: (value) => value.toLowerCase().replace(/ /g, "-"),
          thClass: "skinny-col",
        },
      ];
      if (this.checkStatus)
        fields.push({ key: "action", label: "", thClass: "skinny-col" });

      return fields;
    },
    viewingNewMetric() {
      return this.newProjectMetric;
    },
    viewingProjectMetric() {
      return this.projectMetrics.find(
        (p) => p.projectMetricId === this.viewingProjectMetricId
      );
    },
  },
};
</script>

<style lang="scss" >
td,
th {
  max-width: 200px;
}
</style>